import { render } from "./MessageCenter.vue?vue&type=template&id=4a349734&scoped=true"
import script from "./MessageCenter.vue?vue&type=script&lang=js"
export * from "./MessageCenter.vue?vue&type=script&lang=js"

import "./MessageCenter.vue?vue&type=style&index=0&id=4a349734&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a349734"]])

export default __exports__